import './index.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SuccessMessage from '../../../shared/SuccessMessage';

interface BookSuccessMessageProps {
  onClick: any;
  waitingList?: boolean;
}

const BookSuccessMessage = (props: BookSuccessMessageProps) => {
  const { t } = useTranslation();
  const icon = <i className="icon-glass-martini" />;

  return (
    <div>
      <div className="success-message-container">
        <SuccessMessage
          icon={icon}
          title={t('BOOKED_SUCCESSFULLY')}
          buttonLabel={t('VIEW_BOOKINGS')}
          waitingList={props.waitingList}
          onClick={props.onClick}
        />
      </div>
    </div>
  );
};

export default BookSuccessMessage;
